import { Flex, Heading, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export default function Page404() {
  return (
    <Flex w="100%" minH="70vh" direction="row">
      <Flex
        flex="1"
        h="100%"
        w="100%"
        direction="column"
        justifyContent="center"
        alignItems="center"
        px="40px"
        py="24px">
        <Flex direction="column" justifyContent="flexStart">
          <Heading as="h1" size="4xl">
            404
          </Heading>
          <Heading as="p" size="lg" mb={4}>
            No page exists.
          </Heading>
          <Text as="p" size="xl">
            Use the menu to select a different page{' '}
            <Link as={RouterLink} to="/">
              or return to the dashboard.
            </Link>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
